<template>
	<div style="margin-bottom: 6px;">
		<el-row :gutter="20">
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="status0" title="未开票"></el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="status1" title="待开票"></el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="status2" title="开票中"></el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="status4" title="开票失败"></el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="status3" title="开票成功/待冲红">
						<template slot="formatter">
							{{status3}}/<el-link type="danger" style="font-size: 16px;" @click="checkRefund">{{refund}}
							</el-link>
						</template>
					</el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="day" title="日开票成功"></el-statistic>
				</div>
			</el-col>
		</el-row>




	</div>
</template>
<style>

</style>

<script>
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				like: true,
				status0: 0,
				status1: 0,
				status2: 0,
				status3: 0,
				status4: 0,
				refund: 0,
				day: 0
			}
		},
		watch: {

		},
		mounted() {
			this.static()
		},
		computed: {
			currentMonth() {
				let currentDate = new Date()
				currentDate.setDate(1)
				return currentDate.getTime()
			}
		},

		methods: {
			static() {
				this.$api.invoicecustomerorder.static().then((res) => {
					this.status0 = res.status0
					this.status1 = res.status1
					this.status2 = res.status2
					this.status3 = res.status3
					this.status4 = res.status4
					this.refund = res.refund
					this.day = res.day
				})
			},
			change(e) {
				this.static(e)

			},
			checkRefund() {
				let proxyInfo = this.list.getGrid().getProxyInfo()
				proxyInfo.form.refund_no = '不为空'
				proxyInfo.form.status = 3
				console.log(proxyInfo)
				this.list.getGrid().commitProxy('query')
			}
		},
		components: {

		}
	}
</script>
